import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class ComuneComunali extends Component {
  render() {
    let { regione, provincia, comune} = this.props.params;
    let repoDettaglio = "/elezioni/withub/electionday-2024/comunali/" + regione + "/province/" + provincia + "/" + comune + ".html";
    let repoFascione = "/elezioni/withub/electionday-2024/comunali/fascione-composto.html";
    return (
    <div className="App">
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
        <EWH id="ewh-fascione" repo={repoFascione} />
    </div>
    )
  }
}

export default withParams(ComuneComunali)
